var ConsumerDiscountGeneralDetailsSectionView = require('../ConsumerDiscountLicenseApplication/ConsumerDiscountGeneralDetailsSectionView');

module.exports = ConsumerDiscountGeneralDetailsSectionView;
